import { render, staticRenderFns } from "./TeamHeadingCard.vue?vue&type=template&id=5ad495ec&scoped=true&"
import script from "./TeamHeadingCard.vue?vue&type=script&lang=ts&"
export * from "./TeamHeadingCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeamHeadingCard.vue?vue&type=style&index=0&id=5ad495ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad495ec",
  null
  
)

export default component.exports